import React, { useEffect, useState } from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';
import useOnline from '../hooks/useOnline';
import { size as queueSize } from '../lib/offlineQueue';

export function OfflineBanner() {
  const online = useOnline();
  const [pending, setPending] = useState(0);

  useEffect(() => {
    const tick = () => setPending(queueSize());
    tick();
    const id = setInterval(tick, 1500);
    return () => clearInterval(id);
  }, [online]);

  if (online && pending === 0) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="offline-banner"
      className={`sticky top-0 z-50 w-full text-xs font-medium px-3 py-2 flex items-center justify-center gap-2 ${
        online ? 'bg-[var(--color-teal)]/15 text-[var(--color-teal-deep)]' : 'bg-[var(--color-coral)]/15 text-[var(--color-coral)]'
      }`}
      style={{ paddingTop: `calc(8px + env(safe-area-inset-top))` }}
    >
      {online ? <RefreshCw size={13} className="animate-spin" aria-hidden="true" /> : <WifiOff size={13} aria-hidden="true" />}
      <span>
        {online
          ? `Reconnected — syncing ${pending} change${pending === 1 ? '' : 's'}…`
          : `You're offline. Showing cached data — changes will sync when reconnected.${pending ? ` (${pending} queued)` : ''}`}
      </span>
    </div>
  );
}

export default OfflineBanner;
